
export const uploadsUrl = process.env.CONTENT_URL || 'https://uploads.type2congress.com/Type2virtualbooth_dd300225-7226-4922-ac22-eccabc017714'
export const contentUrl = `${uploadsUrl}/content`
export const videoContentUrl = `${contentUrl}/videos`
export const pdfViewer = `${uploadsUrl}/pdf/web/viewer.html`
export const pdfContentUrl = `${pdfViewer}?file=${contentUrl}/pdfs`
export const screensUrl = `${uploadsUrl}/scenes/room`

